module.exports = __webpack_public_path__ + "static/media/motor.3ea0f739.png";